import React from "react";

interface PillProps {
  name: string;
  className?: string;
  onClick?: () => void;
  backgroundColor?: string;
  style?: React.CSSProperties;
}

const Pill = ({
  name,
  className,
  onClick,
  backgroundColor,
  style,
}: PillProps) => {
  return (
    <button
      style={{ background: backgroundColor, ...style }}
      className={`px-[10px] py-[2px] rounded-[4px] text-[10px] leading-[18px] font-medium text-center truncate overflowAnywhere ${className}`}
      onClick={onClick}
    >
      {name}
    </button>
  );
};

export default Pill;
